import { render, staticRenderFns } from "./FormDetailScoring.vue?vue&type=template&id=e2cdc170&scoped=true&"
import script from "./FormDetailScoring.vue?vue&type=script&lang=js&"
export * from "./FormDetailScoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cdc170",
  null
  
)

export default component.exports